import { imageRegistry } from "../../data/imageRegistry";
import { siteConfig } from "../../content/site";
import { ResponsiveImage } from "../ResponsiveImage/ResponsiveImage";

export function Hero() {
  return (
    <section
      className="hero"
      data-review-region="hero"
      data-auth-signature="matsushima-mobile-first-view"
      data-hero-variant="IMG-HERO-0661"
    >
      <div className="hero__inner">
        <div className="hero__copy">
          <p className="eyebrow">廃車買取のご相談窓口</p>
          <div data-auth-signature="matsushima-service-scope">
            <h1>
              <span className="hero__headline-prefix">その廃車、</span>
              <span className="hero__headline-main">買い取ります。</span>
            </h1>
            <p className="hero__lead">
              <span>沖縄本島全域へ引き取りに伺います。</span>
              <span>レッカー代・抹消手続きは無料です。</span>
            </p>
          </div>

          <div className="hero__phone-group">
            <a
              className="button button--phone button--large hero__primary-phone"
              href={siteConfig.phoneHref}
              data-testid="primary-phone-cta"
              aria-label={`松島オートへ電話して車の査定額を3分で確認する。電話番号 ${siteConfig.phoneDisplay}`}
            >
              <span>車の査定額を3分で確認する</span>
              <strong>{siteConfig.phoneDisplay}</strong>
            </a>
            <p className="contact-note">
              {siteConfig.contactNote}
              <span aria-hidden="true">｜</span>
              {siteConfig.closedDay}
            </p>
            {siteConfig.lineUrl ? (
              <a
                className="hero__secondary-link"
                href={siteConfig.lineUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                公式LINEで相談する
                <span className="sr-only">（新しいタブで開きます）</span>
              </a>
            ) : null}
          </div>

        </div>

        <figure className="hero__visual">
          <ResponsiveImage
            image={imageRegistry.heroLoader}
            className="responsive-image--hero"
            mobilePortrait
            signature="matsushima-real-work-proof"
          />
          <figcaption className="image-caption">
            <span className="hero__caption-text">松島オートの実際の車両引き取り</span>
          </figcaption>
        </figure>
      </div>
    </section>
  );
}
